import { cents as s } from "@systemeio/ui";
const h = ({
  calculatePrice: f,
  productVariant: m,
  product: A,
  quantity: e
}) => f != null && f.netAmount ? f.netAmount : m != null && m.price ? s((m == null ? void 0 : m.price) * e) : s(A.price * e);
export {
  h as getProductPriceWithQuantity
};
